'use client';
import React from 'react';
import {  Factory, Lightbulb, TrendingUp, SlidersHorizontal, HardHat } from 'lucide-react'; // Importing relevant Lucide icons, added SlidersHorizontal and HardHat

const Milestones: React.FC = () => {
  const milestonesData = [
    {
      year: '1995',
      title: 'Founding of Samsan Industrial',
      description: 'Samsan Industrial Company was established with a vision to become a leading provider of industrial solutions, starting with a small team and a focus on local markets.',
      icon: Lightbulb,
    },
    {
      year: '2002',
      title: 'Expansion into Oil & Gas Sector',
      description: 'Diversified operations to include specialized equipment and services for the rapidly growing oil and gas industry, marking a significant strategic move.',
      icon: Factory,
    },
    {
      year: '2008',
      title: 'Launch of Flow Control Solutions Division',
      description: 'Introduced a dedicated division for advanced flow control solutions, catering to the increasing demand for precision and efficiency in industrial processes.',
      icon: SlidersHorizontal, // Using SlidersHorizontal for flow control
    },
    {
      year: '2019',
      title: 'Entry into Heavy Construction Equipment Market',
      description: 'Expanded product offerings to include heavy construction equipment, supporting large-scale infrastructure projects and civil engineering works.',
      icon: HardHat,
    },
    {
      year: '2022',
      title: 'Strategic Partnerships & Global Reach',
      description: 'Formed key international partnerships, significantly expanding our global presence and enhancing our ability to serve clients worldwide.',
      icon: TrendingUp,
    },
  ];

  return (
    <section className="bg-gray-50 text-gray-900 py-16 md:py-24 lg:py-32 overflow-hidden flex flex-col items-center">
      <div className="container mx-auto px-4 text-center relative z-10 max-w-4xl">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-medium mb-6 leading-tight">
          Our Journey: Milestones of Growth
        </h2>
        <p className="text-lg sm:text-xl text-gray-700 mb-12 max-w-3xl mx-auto">
          Discover the key moments that have shaped Samsan Industrial Company into the industry leader it is today.
        </p>

        <div className="relative">
          {/* Vertical line for the timeline */}
          <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-orange-200 hidden md:block"></div>

          {milestonesData.map((milestone, index) => (
            <div
              key={index}
              className={`flex flex-col md:flex-row items-center w-full my-8 ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`}
            >
              {/* Year - Left/Right side on desktop, top on mobile */}
              <div className="md:w-1/2 px-4 text-right md:text-left">
                <p className="text-orange-600 text-3xl font-bold mb-2 md:mb-0">
                  {milestone.year}
                </p>
              </div>

              {/* Icon and Connector - Center on desktop, hidden on mobile */}
              <div className="relative w-10 h-10 flex-shrink-0 bg-orange-500 rounded-full flex items-center justify-center text-white z-10 hidden md:flex">
                <milestone.icon size={24} />
              </div>

              {/* Content Card - Right/Left side on desktop, bottom on mobile */}
              <div className="md:w-1/2 px-4 text-left">
                <div className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">
                    {milestone.title}
                  </h3>
                  <p className="text-gray-700 text-base">
                    {milestone.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Milestones;
